<template>
<div id="user-profile-menu" v-if="show">
    <div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <button @click.prevent="show = null" type="button" class="close float-right">
                                <span aria-hidden="true"><div class="icon icon-close"></div></span>
                            </button>                            
                        </div>
                        <div class="col-12">
                            <div class="title"><small>{{$t('user.popUpMenu.userText')}}:</small> {{user.first_name}} {{user.last_name}}</div>
                        </div>
                        <div class="col-6">
                            <a :href="`/${$t('routes.profile')}`" class="frameLink">
                                <div class="icon icon-user"></div><br>
                                {{$t('user.popUpMenu.editProfile')}}
                            </a>
                        </div>
                        <div class="col-6">
                            <a :href="`/${$t('routes.profile')}/${$t('routes.user-orders')}`" class="frameLink">
                                <div class="icon icon-archive"></div><br>
                                {{$t('user.bottomMenu.orders')}}
                            </a>
                        </div>
                        <div class="col-6">
                            <a :href="`/${$t('routes.profile')}/${$t('routes.user-favorites')}`" class="frameLink">
                                <div class="icon icon-favourites"></div><br>
                                {{$t('user.bottomMenu.favorites')}}
                            </a>
                        </div>
                        <div class="col-6" v-if="$t('user.bottomMenu.card') != ''">
                            <a href="/uporabnik/kartica-ugodnosti" class="frameLink">
                                <div class="icon icon-sm-card"></div><br>
                                {{$t('user.bottomMenu.card')}}
                            </a>
                        </div>
                        <div class="col-12 text-right">
                            <a href="#" class="logout" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">{{$t('user.popUpMenu.btn')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" @click.prevent="show = null"></div>
</div>
</template>

<script>

import Xhr from '@Core/xhr';

import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('user')

export default {

    components: {
    },

    data() {
        return {
            show: null
        }
    },

    computed: {
        ...mapState(['user'])
    },

    created() {
        App.dispatcher.listen('user-profile.open', show => {
            this.show = 1;
        })

        this.getUser()
    },

    methods: {
        ...mapActions(['getUser'])
    }

}
</script>
